import React, { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useSendChatMessage } from '@/modules/AiAgents/apiHooks';
import { AIContext } from '@/modules/AiAgents/context/nugzContext/context';
import { AIActionsTypes } from '@/modules/AiAgents/context/nugzContext/reducer';
import { Loading, MessageItem } from '@/shared/components/atoms';
import ChatInput from '@/shared/components/atoms/ChatInput';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const AIChatContainer = () => {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);
  const containerRef = useRef<HTMLDivElement>(null);

  const {
    state: { messagesList, isLoading },
    dispatch,
  } = useContext(AIContext);
  const { mutate, isLoading: isMessageLoading, data } = useSendChatMessage();

  const handleSendMessage = (val: ChatInputForm) => {
    if (selectedAsset) {
      mutate({
        data: val,
        entityId: selectedAsset?.id,
      });
    }
    dispatch({
      payload: [
        ...messagesList,
        {
          text: val.message ?? '',
          senderName: t('you'),
          type: 'sender',
          timestamp: new Date(),
          file: val.file,
        },
      ],
      type: AIActionsTypes.setMessagesList,
    });
  };

  useEffect(() => {
    if (data) {
      dispatch({
        payload: [
          ...messagesList,
          {
            text: data.response,
            type: 'receiver',
            senderName: t('nugz'),
            timestamp: new Date(data.timestamp),
          },
        ],
        type: AIActionsTypes.setMessagesList,
      });
      // TODO: fix scroll behavior
      if (containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight;
      }
      if (data.fields) {
        dispatch({
          payload: data.fields,
          type: AIActionsTypes.setTableList,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    dispatch({
      payload: isMessageLoading,
      type: AIActionsTypes.setIsLoading,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMessageLoading]);

  return (
    <div
      ref={containerRef}
      id='nugz-chat-container'
      className='flex h-full w-full flex-col gap-24 rounded-xl bg-background-neutral-99 p-16 '
    >
      <div className='scrollbar-hide flex h-full w-full flex-col gap-2 overflow-hidden overflow-y-scroll '>
        {messagesList?.map((item, idx) => (
          <MessageItem {...item} key={idx} />
        ))}
      </div>
      {isLoading && <Loading />}
      <ChatInput
        isDisabled={isLoading || isMessageLoading}
        handleSubmit={handleSendMessage}
      />
    </div>
  );
};

export { AIChatContainer };
